import { enums } from '@kattana-io/common';
import minus from '../../../assets/images/minus.svg';
import Image from '../../../atoms/Image';
import Text from '../../../atoms/Text';
import ColorTag from './ColorTag';

import './styles.scss';

const TAGS = [
  enums.Tag.Blue,
  enums.Tag.Green,
  enums.Tag.Orange,
  enums.Tag.Purple,
  enums.Tag.Red,
  enums.Tag.Yellow,
  enums.Tag.Grey,
];

interface IColorPicker {
  onClose(): void;
  onSelect(color: enums.Tag): void;
  activeTag?: enums.Tag;
  top?: number;
  left?: number;
  right?: number;
}

const ColorPicker = ({
  onClose,
  onSelect,
  activeTag,
  top,
  left,
  right,
}: IColorPicker) => {
  return (
    <>
      <div
        className='price_alert__backdrop'
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      />
      <div
        className='price_alert__create'
        style={{ top, left, right }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className='row'>
          <div className='row'>
            <Text size={14} className='text--grey-200'>
              Change tag color
            </Text>
            <div className='price_alert__create__plus' onClick={onClose}>
              <Image size='s' src={minus} />
            </div>
          </div>
        </div>
        <div className='color_picker'>
          {TAGS.map((tag) => (
            <ColorTag
              key={tag}
              color={tag}
              active={activeTag === tag}
              onClick={() => onSelect(tag)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default ColorPicker;
